import { useState, useCallback } from 'react';

/**
 * useAddForm
 *
 * Owns the Add Form modal tab state:
 *   activeAddFormTab — currently selected tab index in the Add Form modal
 *
 * Also owns the PopulateFormsAndActivitiesList / updateAddFormList helpers
 * so they can be registered in socketCallbacksRef without a class reference.
 *
 * Takes:
 *   calcAPIRef          — ref to calcAPI
 *   isReadOnlyRef       — ref to isReadOnly prop
 *   addFormFirstRef     — ref to addFormFirst Redux state
 *   onSetAddFormPackage — Redux action: setAddFormPackage
 *   onSetFirstAddForm   — Redux action: setFirstAddForm
 *   onToggleAddFormList — Redux action: toggleAddFormList
 *   onSetAddFormList    — Redux action: setAddFormList
 */
const useAddForm = ({
  calcAPIRef,
  isReadOnlyRef,
  addFormFirstRef,
  onSetAddFormPackage,
  onSetFirstAddForm,
  onToggleAddFormList,
  onSetAddFormList,
}) => {
  const [activeAddFormTab, setActiveAddFormTab] = useState(0);

  const populateFormsAndActivitiesList = useCallback(async () => {
    if (addFormFirstRef.current === true) {
      onSetFirstAddForm(false);
      onToggleAddFormList();
    }
  }, [addFormFirstRef, onSetFirstAddForm, onToggleAddFormList]);

  const updateAddFormList = useCallback(
    pkg => {
      onSetAddFormPackage(pkg);
      if (pkg === 'ST') {
        onSetAddFormList([]);
      } else {
        calcAPIRef.current?.ReturnFormList(pkg, isReadOnlyRef.current);
      }
    },
    [calcAPIRef, isReadOnlyRef, onSetAddFormPackage, onSetAddFormList],
  );

  return {
    activeAddFormTab,
    setActiveAddFormTab,
    populateFormsAndActivitiesList,
    updateAddFormList,
  };
};

export default useAddForm;
